export const transactionVerificationErrorCodes = {
    INVALID_TRANSACTION_ADDRESS: 'INVALID_TRANSACTION_ADDRESS',
    INVALID_TRANSACTION_ID_FORMAT: 'INVALID_TRANSACTION_ID_FORMAT',
    INVALID_TRANSACTION_VALUE: 'INVALID_TRANSACTION_VALUE',
    TOKEN_REWARD_ALREADY_PROCESSED: 'TOKEN_REWARD_ALREADY_PROCESSED',
    TOKEN_REWARD_NOT_FOUND: 'TOKEN_REWARD_NOT_FOUND',
    TRANSACTION_NOT_FOUND: 'TRANSACTION_NOT_FOUND',
};
